import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/blog"); setPosts(data); })(); }, []);
  return (
    <main className="pt-28 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="ali-chip">Blog & Insights</div>
        <h1 className="mt-4 font-satoshi font-black text-4xl sm:text-5xl text-[#0A192F] tracking-tight">Sharper minds, better careers.</h1>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map(b => (
            <Link key={b.slug} to={`/blog/${b.slug}`} className="ali-card overflow-hidden group" data-testid={`blog-card-${b.slug}`}>
              <div className="h-48 overflow-hidden"><img src={b.image} alt={b.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" /></div>
              <div className="p-6">
                <p className="text-xs uppercase tracking-widest text-[#FF6B35] font-poppins font-semibold">{b.category}</p>
                <h3 className="mt-2 font-satoshi font-bold text-lg text-[#0A192F]">{b.title}</h3>
                <p className="mt-2 text-sm text-slate-500 font-inter">{b.excerpt}</p>
                <p className="mt-4 text-xs text-slate-400 font-poppins">{b.author} · {b.date}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
